import React from 'react';
import ReactDOM from 'react-dom';

// The vendored DS bundle (design-source/ds/_ds_bundle.js) and its Mission
// Control icon/widget definitions reference a *global* `React` at render time —
// they were authored for the design runtime, not a bundler. Expose it on
// `window` before the bundle module is imported so those lazy references
// resolve. Importing this module for its side effect guarantees the ordering.
declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    CarrTechAIDesignSystem_ad3660?: Record<string, React.ComponentType<any>>;
  }
}

window.React = React;
window.ReactDOM = ReactDOM;

export {};
